import { FC, ReactElement, useState } from 'react'
import styled from 'styled-components'
import useFetch from 'react-fetch-hook'
import ReactLoading from 'react-loading'
import ExampleComponent from '../ExampleComponent'

// Change the year here
const Body: FC = (): ReactElement => {
  const [year, setYear] = useState('2026')
  const { isLoading, data, error } = useFetch(
    `https://storage.googleapis.com/wch-interactive/bilan-jeunes-entrepreneurs/list-${year}.json`,
    {
      formatter: (response: Response) => response.json(),
    }
  )

  return (
    <Container>
      {isLoading ? (
        <LoadingContainer>
          <ReactLoading
            type={'spin'}
            color={'#121212'}
            height={'60px'}
            width={'60px'}
          />
        </LoadingContainer>
      ) : (
        <>
          <ExampleComponent
            data={data}
            onYearChange={setYear}
            year={Number(year)}
          />
        </>
      )}
    </Container>
  )
}

const Container = styled.div`
  background: ${({ theme }) => theme.coloredBackground};
  padding-bottom: 80px;
`

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
`

export default Body
